import { render } from "./CategoryTreeItem.vue?vue&type=template&id=b8a64554&scoped=true"
import script from "./CategoryTreeItem.vue?vue&type=script&lang=js"
export * from "./CategoryTreeItem.vue?vue&type=script&lang=js"

import "./CategoryTreeItem.vue?vue&type=style&index=0&id=b8a64554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a64554"]])

export default __exports__